<script setup lang="ts">
  import DialogActionButton from '@/components/dialog/DialogActionButton.vue'
  import { SpeckleMode, useSpeckleManagement } from '@/composables/useSpeckleManagement'
  import TextField from '@/components/form/TextField.vue'
  import GenericDialog from '@/components/dialog/GenericDialog.vue'
  import SpeckleLoginNoticeDialog from '@/components/dialog/SpeckleLoginNoticeDialog.vue'

  const sectionLineUploadCollectionStore = useSectionLineUploadCollectionsStore()
  const { importSectionLineFromSpeckleDialog } = storeToRefs(sectionLineUploadCollectionStore)
  const speckleManagement = useSpeckleManagement(SpeckleMode.IMPORT_SECTION_LINE)
  const { sectionLineUploadCollectionName, importingSectionLines, canImportSectionLine } =
    speckleManagement

  async function importSectionLinesFromSpeckle() {
    await speckleManagement.importSectionLinesFromSpeckle()
    sectionLineUploadCollectionStore.toggleImportSectionLineFromSpeckleDialog(false)
  }
</script>

<template>
  <GenericDialog
    v-if="speckleManagement.canUseSpeckle.value"
    v-model="importSectionLineFromSpeckleDialog"
    @clicked-outside="
      sectionLineUploadCollectionStore.toggleImportSectionLineFromSpeckleDialog(false)
    "
  >
    <template #title>Receive Section Lines from Speckle</template>
    <template #default>
      <TextField
        v-model="sectionLineUploadCollectionName"
        label="Name of Section Line Collection"
        :rules="[(v: string) => !!v || 'Name is required']"
      ></TextField>
      <SpeckleProjectSearch
        :initialization-function="() => {}"
        :disabled="importingSectionLines"
        class="mt-2"
      ></SpeckleProjectSearch>
      <SpeckleModelSelect
        :disabled="importingSectionLines"
        variant="filled"
        class="mt-2"
      ></SpeckleModelSelect>
      <SpeckleVersionSelectField
        :disabled="importingSectionLines"
        class="mt-2"
      ></SpeckleVersionSelectField>
    </template>
    <template #actions>
      <DialogActionButton
        @click="sectionLineUploadCollectionStore.toggleImportSectionLineFromSpeckleDialog(false)"
      >
        Cancel
      </DialogActionButton>
      <DialogActionButton
        :disabled="!canImportSectionLine"
        :loading="importingSectionLines"
        @click="importSectionLinesFromSpeckle"
      >
        Receive
      </DialogActionButton>
    </template>
  </GenericDialog>
  <SpeckleLoginNoticeDialog v-else v-model="importSectionLineFromSpeckleDialog">
  </SpeckleLoginNoticeDialog>
</template>

<style scoped></style>
